import { DeviceType } from '@wix/cashier-common/dist/src/enums/DeviceType';
import { createSelector } from 'reselect';
import { IStoreState } from '../types/StoreState';

export const selectDeviceType = (state: IStoreState) => state.appState.deviceType;
export const selectMobileType = createSelector(selectDeviceType, (type) => type === DeviceType.Mobile);
